export const pushToDataLayer = (payload) => {
  if (window.dataLayer) {
    window.dataLayer.push(payload);
  } else {
    console.warn("GTM DataLayer not found");
  }
};